import React, { useState } from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { config } from '../../../../config';
import { getMarketSlug } from '../../../../utils/market';
import './LoginForm.css';

function managerPortalSignInUrl() {
  const slug = getMarketSlug();
  const adminBase = config.ADMIN_URL;
  if (slug && slug !== 'default') {
    try {
      const url = new URL(adminBase);
      if (url.hostname === 'localhost' || url.hostname === '127.0.0.1') {
        return `${adminBase}/signin?market=${encodeURIComponent(slug)}`;
      }
      url.hostname = `${slug}.${url.hostname}`;
      return `${url.origin}/signin`;
    } catch {
      return `${adminBase}/signin?market=${encodeURIComponent(slug)}`;
    }
  }
  return `${adminBase}/signin`;
}

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const isOperatorReset = location.pathname === '/reset-password';
  const signInHref = isOperatorReset ? managerPortalSignInUrl() : '/account/signin';

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!token) {
      setError('Invalid reset link. Please request a new password reset.');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(`${config.API_BASE}/api/reset-password`, {
        token,
        password,
      });
      alert(response.data?.message || 'Password updated successfully.');
      if (isOperatorReset) {
        window.location.href = signInHref;
      } else {
        navigate('/account/signin');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Unable to reset password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signin-container">
      <div className="signin-card">
        <div className="signin-header">
          <h1 className="signin-title">Farmers Marketspace</h1>
          <p className="signin-subtitle">Choose a new password</p>
        </div>

        <form onSubmit={handleSubmit} className="signin-form">
          <div className="form-group">
            <label htmlFor="password" className="form-label">New Password</label>
            <input
              type="password"
              className="form-input"
              id="password"
              placeholder="Enter a new password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
            <input
              type="password"
              className="form-input"
              id="confirmPassword"
              placeholder="Confirm your new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
            />
          </div>

          {error && <p style={{ color: '#dc2626', marginBottom: 16 }}>{error}</p>}

          <button type="submit" className="signin-button" disabled={loading || !token}>
            {loading ? 'Updating...' : 'Update Password'}
          </button>
        </form>

        <div className="register-section">
          {isOperatorReset ? (
            <a href={signInHref} className="register-link" style={{ marginLeft: 0 }}>
              Back to sign in
            </a>
          ) : (
            <Link to="/account/signin" className="register-link" style={{ marginLeft: 0 }}>
              Back to sign in
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
